// Product Finder (Keepa) API. The Keepa key stays on the server; these calls only
// ever return the categories and products the signed-in user asked for.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/product-finder`;

const headers = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

// Resolves with the JSON body; rejects with an Error carrying status and body.
const call = async (token, path, { method = 'GET', body } = {}) => {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: headers(token),
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = {};
  try {
    data = await res.json();
  } catch (e) {
    // non-JSON error page
  }
  if (!res.ok || data.success === false) {
    const err = new Error(data.error || `Request failed (${res.status})`);
    err.status = res.status;
    err.body = data;
    throw err;
  }
  return data;
};

export const getStatus = (token) => call(token, '/status');
export const getRootCategories = (token, domain) =>
  call(token, `/categories/roots?domain=${domain}`).then((d) => d.categories);
export const getChildCategories = (token, domain, id) =>
  call(token, `/categories/${id}/children?domain=${domain}`).then((d) => d.categories);
export const searchCategories = (token, domain, q) =>
  call(token, `/categories/search?domain=${domain}&q=${encodeURIComponent(q)}`).then((d) => d.categories);
export const estimateTokens = (token, body) => call(token, '/estimate', { method: 'POST', body });
export const startSearch = (token, body) => call(token, '/searches', { method: 'POST', body });
export const listSearches = (token) => call(token, '/searches').then((d) => d.searches);
export const getSearch = (token, id) => call(token, `/searches/${id}`).then((d) => d.search);
export const updateLandedCost = (token, id, landedCostPct, overrides) =>
  call(token, `/searches/${id}/landed-cost`, {
    method: 'POST',
    body: { landed_cost_pct: landedCostPct, overrides },
  }).then((d) => d.search);
